import { Kind } from "graphql";
import { isDefinedOnQuery } from "./composableFragment";
import { getFragmentDefinitions } from "./fragment";
function getEntryPointQuery(document) {
    return document.definitions.find((def)=>def.kind === Kind.OPERATION_DEFINITION);
}
export function findEntryPointQuery(document) {
    const queryDefinition = getEntryPointQuery(document);
    if (!queryDefinition) {
        throw new Error(`No query defined in the document`);
    }
    return queryDefinition;
}
export function getFieldNodes(document) {
    const queryEntryPoint = findEntryPointQuery(document);
    const fieldNodes = queryEntryPoint.selectionSet.selections.filter((selection)=>selection.kind === Kind.FIELD);
    return fieldNodes;
}
export function getFieldNodesWithSpreadFragmentFields(document) {
    const queryEntryPoint = findEntryPointQuery(document);
    const entrypointFieldNodes = queryEntryPoint.selectionSet.selections.filter((selection)=>selection.kind === Kind.FIELD);
    const fragmentDefinitions = getFragmentDefinitions(document);
    if (fragmentDefinitions.length === 0) {
        return entrypointFieldNodes;
    }
    const entryPointUsedFragments = queryEntryPoint.selectionSet.selections.filter((selection)=>selection.kind === Kind.FRAGMENT_SPREAD);
    const spreadFragmentFields = entryPointUsedFragments.flatMap((spreadFragment)=>getFieldNodesFromSpreadFragment(spreadFragment, fragmentDefinitions));
    return [
        ...entrypointFieldNodes,
        ...spreadFragmentFields
    ];
}
function getFieldNodesFromSpreadFragment(spreadFragment, fragmentDefinitions) {
    const fragmentDefinition = fragmentDefinitions.find((fragment)=>fragment.name.value === spreadFragment.name.value);
    if (!fragmentDefinition) {
        return [];
    }
    const fragmentFieldNodes = fragmentDefinition.selectionSet.selections.filter((selection)=>selection.kind === Kind.FIELD);
    const spreadFragmentFieldNodes = fragmentDefinition.selectionSet.selections.filter((selection)=>selection.kind === Kind.FRAGMENT_SPREAD);
    const nestedSpreadFragmentFieldNodes = spreadFragmentFieldNodes.flatMap((spreadFragmentNode)=>getFieldNodesFromSpreadFragment(spreadFragmentNode, fragmentDefinitions));
    return [
        ...fragmentFieldNodes,
        ...nestedSpreadFragmentFieldNodes
    ];
}
export function findEntryPointDefinition(document) {
    // First try finding query
    const queryDefinition = getEntryPointQuery(document);
    if (queryDefinition) {
        return queryDefinition;
    }
    // Else find fragment
    const composableFragment = document.definitions.find((def)=>def.kind === Kind.FRAGMENT_DEFINITION);
    if (!composableFragment || !isDefinedOnQuery(composableFragment)) {
        throw new Error(`No fragment defined on Query found`);
    }
    return composableFragment;
}

//# sourceMappingURL=entrypoint.js.map